import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type ReactElement } from 'react'

import { slugify } from '@lib/utils/strings'

import { type PolymorphicElementProps } from '../types'

import styles from './list.module.scss'

type ListTag = 'ul' | 'ol'

export type ListProps = ComponentPropsWithoutRef<ListTag> &
  PolymorphicElementProps<ListTag> & {
    type?: 'unordered' | 'ordered'
    items?: string[]
    itemClassName?: string
  }

export function List({
  type = 'unordered',
  items = [],
  children,
  className,
  itemClassName,
  ...rest
}: ListProps): ReactElement {
  const Component = type === 'ordered' ? 'ol' : 'ul'

  return (
    <Component
      className={clsx(
        styles.list,

        className,
      )}
      {...rest}
    >
      {items?.length &&
        items.map((item, index) => (
          <li key={`${index}-${slugify(item)}`} className={clsx(styles.listItem, itemClassName)}>
            {item}
          </li>
        ))}
      {children}
    </Component>
  )
}
